import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15.2 15.3",
	style: { enableBackground: "new 0 0 15.2 15.3" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.link-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "link-icon-st0",
		d: "M14,1.2c-0.4-0.4-0.8-0.7-1.3-0.9S11.7,0,11.1,0s-1,0.1-1.5,0.3S8.7,0.8,8.3,1.2L6.7,2.7 C6.6,2.9,6.6,3,6.6,3.2c0,0.1,0,0.3,0.1,0.4S7,3.8,7.1,3.8c0.2,0,0.4-0.1,0.5-0.2l1.5-1.5c0.5-0.5,1.2-0.8,2-0.8 c0.7,0,1.5,0.3,2,0.8c0.3,0.2,0.5,0.5,0.6,0.9c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.7-0.6,0.9l-2.2,2.2 c-0.5,0.5-1.2,0.8-2,0.8c-0.8,0-1.5-0.3-2-0.8C6.8,8.2,6.8,8.2,6.7,8.2c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.2,0.1-0.2,0.1C6,8.3,6,8.3,6,8.4c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2C7,9.8,8,10.2,9.1,10.2 S11.2,9.8,12,9l2.2-2.2c0.2-0.2,0.5-0.7,0.7-1.2c0.2-0.5,0.3-1,0.3-1.6c0-0.5-0.1-1.1-0.3-1.6C14.7,2,14.4,1.6,14,1.2z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "link-icon-st0",
		d: "M7.6,11.6l-1.5,1.5c-0.5,0.5-1.2,0.8-2,0.8c-0.7,0-1.4-0.3-2-0.8c-0.5-0.5-0.8-1.2-0.8-2 c0-0.7,0.3-1.4,0.8-2l2.2-2.2c0.5-0.5,1.2-0.8,2-0.8s1.5,0.3,2,0.8C8.4,7,8.6,7.1,8.7,7.1C8.8,7.1,9,7,9.1,6.9 c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C8.3,5.3,7.3,4.9,6.2,4.9S4.1,5.3,3.3,6.1L1.1,8.3C0.8,8.6,0.5,9.1,0.3,9.6 S0,10.6,0,11.2c0,0.5,0.1,1.1,0.3,1.6s0.5,1,0.9,1.3C1.6,14.5,2,14.8,2.5,15c0.5,0.2,1,0.3,1.6,0.3c0.5,0,1.1-0.1,1.6-0.3 c0.5-0.2,0.9-0.5,1.3-0.9l1.5-1.5c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.4-0.2 C7.9,11.4,7.7,11.5,7.6,11.6z"
	})] }) }) })]
});
export default SvgLinkIcon;
